import * as React from "react";
import StreamFailureCountCell from "./StreamFailureCountCell";
export const FAILURE_COUNT_ATTRIBUTE_NAME = "failure_count";
const streamFailureColumn = {
  attributeName: FAILURE_COUNT_ATTRIBUTE_NAME,
  group: "performance",
  attributes: [{ id: FAILURE_COUNT_ATTRIBUTE_NAME, title: "Failure Count (Last 24H)", type: "INT" }],
  columnRenderers: {
    [FAILURE_COUNT_ATTRIBUTE_NAME]: {
      renderCell: (_value, stream) => /* @__PURE__ */ React.createElement(StreamFailureCountCell, { stream }),
      staticWidth: 180
    }
  },
  metricFields: {
    [FAILURE_COUNT_ATTRIBUTE_NAME]: [FAILURE_COUNT_ATTRIBUTE_NAME]
  }
};
export default streamFailureColumn;
